import React from 'react';
import PropTypes from 'prop-types';
import { useCreditCardPCIData, usePaymentInstrumentToken } from '@edreamsodigeo/frontend-checkout';
import { MembershipProductEvaluationProvider } from '@edreamsodigeo/frontend-prime';
const MembershipProductEvaluation = ({
  children,
  funnel
}) => {
  const {
    firstNumberDigits,
    expirationMonth,
    expirationYear
  } = useCreditCardPCIData();
  const paymentInstrumentToken = usePaymentInstrumentToken();
  return /*#__PURE__*/React.createElement(MembershipProductEvaluationProvider, {
    funnel: funnel ?? 'flights',
    paymentInstrumentToken: paymentInstrumentToken,
    creditCardBin: firstNumberDigits,
    expirationMonth: expirationMonth,
    expirationYear: expirationYear
  }, children);
};
MembershipProductEvaluation.propTypes = {
  children: PropTypes.node.isRequired,
  funnel: PropTypes.oneOf(['flights', 'dynpack', 'hotels', 'cars'])
};
export default MembershipProductEvaluation;